/* eslint-disable no-nested-ternary */
import { isMobile } from '../../../utils/device-utils';
import {
  getMatchStatusLabel,
  isEndedAfterOverTime,
  isEndedAfterShootout,
  isLive,
  isEnded,
} from '../../../utils/match-status';
import { MatchStatusType } from '../../../typings/match';
import { FontWeight } from '../../../typings/design-tokens';
import t from '../../../labels/labelling-utils';
import { dateFormat } from '../../../utils/times';

import { Winner } from './competition-board-card';

export const getStatusLabel = (status: MatchStatusType): string => {
  if (isLive(status)) {
    return 'LIVE';
  }

  if (isEndedAfterOverTime(status)) {
    return 'DTS';
  }

  if (isEndedAfterShootout(status)) {
    return 'DCR';
  }

  return getMatchStatusLabel(status) || '';
};

export const getScoreWeight = (params: { team: 'home' | 'away'; winner?: Winner }): FontWeight => {
  const { team, winner = undefined } = params;

  if (team === winner!) {
    return '700';
  }

  return '500';
};

export const getTeamName = (teamName: string): string => {
  return teamName.toLowerCase() === t('competition.board.noname').toLowerCase()
    ? t('competition.board.noname')
    : teamName.toUpperCase();
};

export const getCardHeader = (status: MatchStatusType, date: string): string => {
  return isEnded(status)
    ? t('match-end')
    : isMobile()
    ? `${dateFormat({ date, format: 'ddd D MMM' })} | ore ${dateFormat({
        date,
        format: 'HH:mm',
      })}`
    : `${dateFormat({ date, format: 'D MMM' })} | ${dateFormat({
        date,
        format: 'HH:mm',
      })}`;
};
